import React from "react";

export const Logo = ({ className = "" }) => (
  <a
    href="/"
    className={`flex items-center gap-3 group select-none ${className}`}
    data-testid="logo-home-link"
  >
    {/* Modern Gold Eclipse / Ring Emblem */}
    <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-amber-500 via-amber-600 to-yellow-600 p-0.5 shadow-md shadow-amber-500/20 group-hover:scale-105 transition-transform duration-300">
      <div className="flex h-full w-full items-center justify-center rounded-[10px] bg-zinc-950">
        <svg
          viewBox="0 0 32 32"
          className="h-5 w-5"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="asta-gold-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FDE68A" />
              <stop offset="50%" stopColor="#F59E0B" />
              <stop offset="100%" stopColor="#D97706" />
            </linearGradient>
            <mask id="asta-crescent">
              <rect width="32" height="32" fill="white" />
              <circle cx="19" cy="13" r="8" fill="black" />
            </mask>
          </defs>
          <g mask="url(#asta-crescent)">
            <circle
              cx="16"
              cy="16"
              r="10.5"
              fill="none"
              stroke="url(#asta-gold-grad)"
              strokeWidth="2.8"
            />
          </g>
          <circle cx="16" cy="16" r="3.5" fill="url(#asta-gold-grad)" />
        </svg>
      </div>
    </div>

    {/* Brand Typography (asta in bold black, enterprise in amber-700) */}
    <div className="flex flex-col">
      <div className="flex items-baseline text-xl font-bold tracking-tight leading-none">
        <span className="text-zinc-950 font-extrabold">asta</span>
        <span className="text-amber-700 font-bold ml-0.5">enterprise</span>
      </div>
      <span className="text-[10px] uppercase font-bold tracking-[0.18em] text-zinc-600 leading-none mt-1">
        Gold Solution
      </span>
    </div>
  </a>
);

export default Logo;
